import React from 'react'
import Layout from '../components/layout2'
import Container from '../components/container'
import Box from '../components/box'
import Case from '../components/case'
import Vbox from '../components/vbox'
import Img from '../components/img'
import Summary from '../components/summary'

class RootIndex extends React.Component {
  render() {
    return (
      <Layout>
        <svg
          style={{
            position: 'absolute',
            left: 0,
            top: -150,
            bottom: 0,
            right: 0,
            zIndex: -1,
          }}
          viewBox="0 0 1389 3903"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g filter="url(#filter0_n_1150_3082)">
            <path
              d="M0 2566.9C55.5563 2553.65 116.009 2575.66 149.028 2626.51L150.783 2629.21C169.454 2657.96 197.877 2679 230.824 2688.47L325.633 2715.72C353.494 2723.73 379.282 2737.7 401.21 2756.66L497.526 2839.95C556.561 2891 580.506 2971.72 558.857 3046.71L513.854 3202.58C497.184 3260.32 455.433 3307.5 400.15 3331.08L285.016 3380.17C209.385 3412.42 181.686 3505.47 227.366 3573.83L361.076 3773.93C384.32 3808.71 351.242 3853.49 311.162 3841.5C300.127 3838.19 288.242 3839.29 277.992 3844.54L208.024 3880.43C163.882 3903.07 112.901 3908.49 64.9824 3895.65L0 3878.24V2566.9Z"
              fill="#FFF9B8"
            />
            <path
              d="M988.68 1952.52C1039.35 1888.01 1134.17 1880.17 1194.74 1935.49L1199.88 1940.18C1226.55 1964.53 1261.21 1978.26 1297.32 1978.76L1357.54 1979.59C1367.82 1979.74 1378.01 1980.67 1388.02 1982.36V3299.72L1225.19 3300.53C1199.06 3300.66 1173.15 3295.67 1148.94 3285.83L1052.61 3246.71C975.494 3215.39 925.838 3139.58 927.931 3056.38L932.302 2882.6C932.925 2857.82 938.148 2833.38 947.705 2810.51L966.88 2764.63C998.626 2688.67 980.58 2601.01 921.409 2543.77L822.935 2448.5C789.321 2415.98 768.166 2372.71 763.15 2326.21L750.973 2213.3C740.697 2118.03 802.222 2029.77 895.158 2006.46L912.066 2002.22C942.408 1994.6 969.359 1977.12 988.68 1952.52Z"
              fill="#FFF9B8"
            />
            <path
              d="M405.518 886C422.539 886 439.491 888.173 455.962 892.466L690.006 953.469C698.558 955.698 707.36 956.826 716.198 956.826H742.637C797.411 956.826 837.345 1008.68 823.353 1061.64C817.849 1082.47 820.61 1104.62 831.058 1123.46L861.618 1178.56C885.678 1221.95 892.754 1272.73 881.474 1321.04L823.483 1569.39C817.731 1594.03 807.357 1617.35 792.912 1638.11L745.088 1706.87C696.005 1777.44 607.319 1808.75 524.809 1784.65L392.635 1746.03C368.129 1738.87 345.221 1727.08 325.147 1711.31L304.874 1695.38C237.417 1642.37 143.664 1638.28 71.8545 1685.23L0 1732.21V897.631C21.4988 889.96 44.2267 886 67.207 886H405.518Z"
              fill="#FFF9B8"
            />
            <path
              d="M1111.42 0C1127.46 0 1143.44 1.92991 1159.02 5.74707L1385.37 61.209C1386.25 61.4253 1387.13 61.6275 1388.02 61.8193V787.876C1341.05 818.285 1282.39 828.263 1226.32 812.863L1113.02 781.745C1080.11 772.704 1050.05 755.388 1025.72 731.445L927.706 634.998C850.176 558.709 719.481 590.521 685.686 693.907C663.672 761.248 596.627 803.191 526.441 793.527L484.124 787.7C401.948 776.386 340.729 706.16 340.729 623.208V607.9C340.729 580.686 331.606 554.258 314.82 532.838C270.852 476.731 284.305 395.017 343.939 355.967L349.604 352.258C375.882 335.05 394.911 308.774 403.062 278.438L413.539 239.441C428.183 184.94 465.172 139.161 515.383 113.396L693.386 22.0586C721.638 7.56143 752.937 2.96346e-05 784.692 0H1111.42Z"
              fill="#FFF9B8"
            />
            <path
              d="M241.578 306.651C252.3 298.84 259.529 304.116 267.34 314.838C275.151 325.559 277.085 332.861 266.363 340.672C255.642 348.483 247.078 346.011 239.268 335.289C231.457 324.568 232.583 319.071 241.578 306.651Z"
              fill="#FFF9B8"
            />
            <path
              d="M347.003 197.455C374.617 197.455 385.996 212.111 385.996 239.726C385.996 267.34 374.617 285.078 347.003 285.078C319.389 285.078 297.003 262.692 297.003 235.078C297.003 207.464 319.389 197.455 347.003 197.455Z"
              fill="#FFF9B8"
            />
          </g>
          <defs>
            <filter
              id="filter0_n_1150_3082"
              x="0"
              y="0"
              width="1388.02"
              height="3902.47"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
            >
              <feFlood flood-opacity="0" result="BackgroundImageFix" />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feTurbulence
                type="fractalNoise"
                baseFrequency="0.5 0.5"
                stitchTiles="stitch"
                numOctaves="3"
                result="noise"
                seed="2332"
              />
              <feColorMatrix
                in="noise"
                type="luminanceToAlpha"
                result="alphaNoise"
              />
              <feComponentTransfer in="alphaNoise" result="coloredNoise1">
                <feFuncA
                  type="discrete"
                  tableValues="0 0 0 0 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 "
                />
              </feComponentTransfer>
              <feComposite
                operator="in"
                in2="shape"
                in="coloredNoise1"
                result="noise1Clipped"
              />
              <feFlood
                flood-color="rgba(255, 255, 255, 0.4)"
                result="color1Flood"
              />
              <feComposite
                operator="in"
                in2="noise1Clipped"
                in="color1Flood"
                result="color1"
              />
              <feMerge result="effect1_noise_1150_3082">
                <feMergeNode in="shape" />
                <feMergeNode in="color1" />
              </feMerge>
            </filter>
          </defs>
        </svg>

        <Container>
          <h1 style={{ marginTop: '32px' }} className="h1">
            Contact Me
          </h1>
          <Summary>
            <h4 className="h4">Message me on LinkedIn</h4>
            <p className="small">Frida Runnakko</p>
            <h4 className="h4">Email me</h4>
            <p className="small">frida.runnakko@gmail.com</p>
            <h4 className="h4">Call or text</h4>
            <p className="small">+46704186212</p>
          </Summary>
        </Container>
      </Layout>
    )
  }
}

export default RootIndex
